/** @format */

import {clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function addTWPrefixToClasses(classes) {
    if (!classes) {
        return '';
    }
    return classes
        .split(' ')
        .map(c => {
            if (c.startsWith('tw-')) {
                return c;
            }

            if (c.includes(':')) {
                const statePart = c.split(':')[0];
                const classPart = c.split(':')[1];

                if (classPart.startsWith('tw-')) {
                    return c;
                }

                return `${statePart}:tw-${classPart}`;
            }

            return `tw-${c}`;
        })
        .join(' ');
}
